var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.state.app.embedMode)?_c('div',{staticClass:"footer"},[_c('h3',[_vm._t("headline",[_vm._v("Join more than 4,000,000 students & teachers on StudySync")])],2),_vm._v(" "),_c('div',{staticClass:"cta"},[_vm._t("cta",[_c('btn',[_c('router-link',{attrs:{"to":{name: 'freeTrial'}}},[_vm._v("Start a Free Trial")])],1)])],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ddfdb26","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterCTA.vue
// module id = null
// module chunks = 